import React from 'react';
import { ArrowDown, SpinnerGap } from '@phosphor-icons/react';

const PullToRefreshIndicator = ({ pullDistance, pullProgress, isRefreshing, threshold = 80 }) => {
  if (pullDistance <= 0 && !isRefreshing) return null;

  const opacity = Math.min(pullProgress * 1.5, 1);
  const scale = 0.5 + (pullProgress * 0.5);
  const rotation = pullProgress * 180;
  const isReady = pullProgress >= 1;

  return (
    <div 
      className="flex items-center justify-center transition-all duration-150 ease-out overflow-hidden"
      style={{ 
        height: `${Math.max(pullDistance, isRefreshing ? threshold : 0)}px`,
        opacity: isRefreshing ? 1 : opacity
      }}
    >
      <div 
        className={`flex flex-col items-center gap-1 transition-transform duration-150 ${
          isReady || isRefreshing ? 'text-[#4f9eff]' : 'text-[#8b949e]'
        }`}
        style={{ 
          transform: `scale(${isRefreshing ? 1 : scale})` 
        }}
      >
        {isRefreshing ? (
          <>
            <SpinnerGap size={24} className="animate-spin" weight="bold" />
            <span className="font-['IBM_Plex_Mono'] text-xs">Actualizando...</span>
          </>
        ) : (
          <>
            <ArrowDown 
              size={24} 
              weight="bold"
              style={{ 
                transform: `rotate(${rotation}deg)`,
                transition: 'transform 0.15s ease-out'
              }}
            />
            <span className="font-['IBM_Plex_Mono'] text-xs">
              {isReady ? 'Soltar para actualizar' : 'Desliza para actualizar'}
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default PullToRefreshIndicator;
